import {
  getMaterialsList,
  postRemove,
  getMaterialsListFilteredOrdered,
  getMaterialsExportList,
  postUpdateAddAllExport,
  getExportModel
} from "./services";

export async function getMaterialsListAction({ commit }) {
  try {
    return (await getMaterialsList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function getMaterialsExportListAction({ commit }) {
  try {
    return (await getMaterialsExportList()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getMaterialsListFilteredOrderedAction({ commit }, payload) {
  try {
    return (await getMaterialsListFilteredOrdered(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function remove({ commit }, payload) {
  try {
    return (await postRemove(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function postUpdateAddAllExportAction({ commit }, payload) {
  try {
    return (await postUpdateAddAllExport(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getExportModelAction({ commit }) {
  try {
    return (await getExportModel()).data;
  } catch (e) {
    console.log(e);
  }
}